export default function GameMenu({onSendLeaveGame}) {
    const sendValue = () => {
        console.log('test')
        onSendLeaveGame(true);
    };
    return (
        <div className="game-menu">
            <div className="exit item" onClick={sendValue}>
                <div className="exit-icon"></div>
                {/* <img src="<?php echo base_url('svgIcons/cross-game-icon.svg'); ?>" alt="Quitter" /> */}
                <p>Quitter</p>
            </div>
            <div id="switchNoiseSound" className="sound item <?= $session->get('User_Settings_GameSoundEffectsState') ? 'soundOn' : 'soundOff' ?>">
                <div className="sound-icon"></div>
                {/* <img src="<?= $session->get('User_Settings_GameSoundEffectsState') ? base_url('svgIcons/sound-effects-icon.svg') : base_url('svgIcons/sound-effects-off-icon-black.svg') ?>" alt="Effets sonores" /> */}
                <p>Effets sonores</p>
            </div>
            <div id="switchAmbientSound" className="music item <?= $session->get('User_Settings_GameMusicState') ? 'musicOn' : 'musicOff' ?>">
                <div className="music-icon"></div>
                {/* <img src="<?= $session->get('User_Settings_GameMusicState') ? base_url('svgIcons/sound-effects-icon.svg') : base_url('svgIcons/music-icon-black.svg') ?>" alt="Musique" /> */}
                <p>Musique</p>
            </div>
            <div className="lvl-up item">
                <div className="lvl-up-icon"></div>
                {/* <img src="<?php echo base_url('svgIcons/level-up-icon.svg'); ?>" alt="Niveau sup" /> */}
                <p>Niveau sup</p>
            </div>
            <div className="lvl-down item">
                <div className="lvl-down-icon"></div>
                {/* <img src="<?php echo base_url('svgIcons/level-down-icon.svg'); ?>" alt="Niveau inf" /> */}
                <p>Niveau inf</p>
            </div>
        </div>
    );
}